import type React from "react"
import { TextField, type TextFieldProps } from "@mui/material"

const FormTextField: React.FC<TextFieldProps> = (props) => {
  return (
    <TextField
      {...props}
      sx={{
        "& .MuiFilledInput-root": {
          borderRadius: 2,
          "&:before, &:after": {
            display: "none",
          },
        },
        "& .MuiFormHelperText-root": {
          color: props.error ? "error.main" : "inherit",
          marginLeft: 0,
        },
        ...props.sx,
      }}
    />
  )
}

export default FormTextField
